import { useState } from "react";
import { API_URL } from "../../context/AuthContext";
import { Alert, Button } from "@mui/material";
import type { ProductData } from "./Dashboard";

interface TranslateAllButtonProps {
  product: ProductData;
  token: string | null;
  onTranslated: () => void;
}

export default function TranslateAllButton({ product, token, onTranslated }: TranslateAllButtonProps) {
  const [translating, setTranslating] = useState(false);
  const [msg, setMsg] = useState("");

  const handleTranslateAll = async () => {
    setTranslating(true);
    try {
      await fetch(`${API_URL}/api/products/${product.id}/translate-related`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      setMsg("Przetłumaczono brakujące pola");
      onTranslated();
    } catch {
      setMsg("Błąd tłumaczenia");
    } finally {
      setTranslating(false);
    }
  };

  return (
    <>
      {msg && <Alert severity="info" sx={{ mb: 2 }} onClose={() => setMsg("")}>{msg}</Alert>}
      <Button size="small" onClick={handleTranslateAll} disabled={translating} sx={{ color: "#ff9800", mb: 2 }}>
        {translating ? "Tłumaczenie..." : "Tłumacz nieprzetłumaczone na angielski"}
      </Button>
    </>
  );
}
